/* ══════════════════════════════════════════════════════════════════════
   Skön Cosmetics — skon-quiz-texts.js
   asset: assets/skon-quiz-texts.js
   Aggiornato: 18 maggio 2026 — 12:53
   Versione: 2.6

   Modifiche v2.6:
   - Aggiunte 3 chiavi a SKON_TEXTS.result per il flow "Aggiungi tutta la
     routine" con checkout diretto (v2.4.0 del JS):
     · toastRoutineAdded: messaggio toast bottom-center mostrato per 2s
       prima del redirect al checkout
     · toastRoutineError: messaggio fallback se add-to-cart fallisce in
       modo parziale (con interpolazione {{ok}} / {{total}})
     · ctaAddingShort: "Aggiungo…" (era hardcoded in addAllToCart)
   - REQUISITO: skon-quiz.js v2.4.0+

   Modifiche v2.5:
   - Aggiunta chiave SKON_TEXTS.result.ctaAddRoutineSubRC come placeholder
     neutro per il sub-line del bottone "Aggiungi tutta la routine" in
     modalità RC. Default: "Lo sconto si applica automaticamente al carrello".
     Coerente con DISCOUNT_CONFIG.returnBadgeNote.
   - Sarà sostituito in v2.6+ dal calcolo live via Storefront API cartCreate
     (stesso pattern di skon-pdp-live-price.js).

   Modifiche v2.4:
   - Aggiunte 2 chiavi a SKON_TEXTS.result:
     · btnViewProductSheet: 'Vedi prodotto' (era 'Vedi la scheda completa'
       hardcoded nel Liquid sotto il CTA Add-to-cart del variant sheet)
     · varSectionLabel: 'Seleziona la variante' (era hardcoded nel Liquid)
   - Migrate dal Liquid al JS per coerenza con il pattern "SKON_TEXTS fonte
     autoritativa unica" introdotto in v2.3.

   Modifiche v2.3:
   - Espanso SKON_TEXTS.result da 9 a 18 chiavi: include TUTTI i testi UI
     della schermata risultato + sheet correlati (detail sheet, variant sheet,
     lightbox AK, bottoni add-to-cart, stati post-click, restart).
   - Prima della v2.3 SKON_TEXTS.result era codice morto (testi hardcoded
     in skon-quiz.js). Bug architetturale identico a quello risolto in v2.2
     per SKON_TEXTS.questions. Dalla v2.3 chiude definitivamente il pattern.
   - Marketing può ora editare ogni testo UI della schermata risultato
     modificando ESCLUSIVAMENTE questo file.
   - REQUISITO: richiede skon-quiz.js v2.3.3+ (con helper _t() che legge
     SKON_TEXTS.result con interpolazione di placeholder {{var}}).

   Modifiche v2.2:
   - Arricchito SKON_TEXTS.questions con tutti i dati necessari al rendering
     UI degli step quiz. Prima della v2.2 i testi erano hardcoded in
     quiz-main.liquid e SKON_TEXTS era codice morto. Ora SKON_TEXTS è fonte
     autoritativa unica:
     · skin options: aggiunto pillClass (es. 'normale' → opt-pill--normale)
     · desire options: aggiunto emoji (✨💧🌿🌸☀️)
     · spf options:    aggiunto emoji (☀️🌤️🌊🌙🌿)
   - REQUISITO: richiede skon-quiz.js v2.3.2+ (con renderQuestionScreens())
     e quiz-main.liquid v2.0+ (shell con screen vuoti).

   Modifiche v2.1:
   - Label fasce d'età estese a testo discorsivo (no sovrapposizione bordi):
     · 'lt25'   label: '<25'   → 'Meno di 25 anni'
     · '25-35'  label: '25-35' → 'Da 26 a 35 anni'
     · '35-45'  label: '35-45' → 'Da 36 a 45 anni'
     · '45-55'  label: '45-55' → 'Da 46 a 55 anni'
     · '55plus' label: '55+'   → 'Oltre i 55 anni'
   - Rimosso campo skinDesc dalle opzioni età (non più necessario, UX unificata
     con altri step del quiz che hanno una sola label discorsiva).
   - Slug DB (campo 'value') INVARIATI: lt25, 25-35, 35-45, 45-55, 55plus
     → nessuna rottura record Magnews esistenti, lookup routine, audience.

   Versione storica:
   - 2.0 — 28 aprile 2026 (nuovo modello quiz — lookup 5×5×5 → 28 routine)
   
   FILE EDITABILE DAL TEAM MARKETING.
   Modificare solo i valori stringa (ciò che sta tra le virgolette).
   NON modificare: chiavi, virgole, parentesi, struttura dell'oggetto.

   DEPLOYMENT: defer, dopo skon-quiz-priority.js e skon-quiz-routines.js,
               prima di skon-quiz.js
══════════════════════════════════════════════════════════════════════ */


window.SKON_TEXTS = {

  /* ----------------------------------------------------------------
     1. DOMANDE DEL QUIZ
     Testi delle 4 domande e delle loro opzioni.
     Fonte: Sko_n_Skin_Test_V3.xlsx — foglio Q&A
     Refusi corretti: "spoecchio" → "specchio", "mie pelle" → "mia pelle",
                      "prchè" → "perché", chiusura virgolette Q3/libera_imperfezioni
  ---------------------------------------------------------------- */
  questions: {

    /* Q1 — Età */
    age: {
      label:   '1 di 4 · La tua età',
      title:   'Quanti anni hai?',
      sub:     'Ogni decade porta con sé cambiamenti biologici della pelle: sapere da dove partiamo è il primo passo per costruire una routine davvero efficace.',
      options: [
        { value: 'lt25',   label: 'Meno di 25 anni'   },
        { value: '25-35',  label: 'Da 26 a 35 anni'   },
        { value: '35-45',  label: 'Da 36 a 45 anni'   },
        { value: '45-55',  label: 'Da 46 a 55 anni'   },
        { value: '55plus', label: 'Oltre i 55 anni'   },
      ],
    },

    /* Q2 — Tipo di pelle (autopercezione)
       Le label primarie sono testi lunghi + tag classificatorio secondario.
       primary = testo narrativo | secondary = etichetta sintetica
    */
    skin: {
      label:   '2 di 4 · La tua pelle',
      title:   'Guardandoti allo specchio vedi\u2026',
      options: [
        {
          value:     'normale',
          primary:   '\u2026la mia pelle sana, idratata e uniforme.',
          secondary: 'Pelle normale',
          pillClass: 'opt-pill--normale',
        },
        {
          value:     'disidratata',
          primary:   '\u2026linee sottili e grana irregolare. La mia pelle è poco luminosa e avverto spesso una sensazione di discomfort.',
          secondary: 'Pelle disidratata',
          pillClass: 'opt-pill--disidratata',
        },
        {
          value:     'secca_sensibile',
          primary:   '...rossori e screpolature specialmente in seguito a sbalzi di temperatura. La mia pelle è fragile e sottile, spesso ruvida al tatto.',
          secondary: 'Pelle secca/sensibile',
          pillClass: 'opt-pill--secca',
        },
        {
          value:     'mista_grassa',
          primary:   '\u2026imperfezioni come brufoli e punti neri, la grana è irregolare e i pori sono particolarmente visibili. Nel corso della giornata la mia pelle diventa lucida nella zona T e è invece più secca sulle guance.',
          secondary: 'Pelle mista/grassa/soggetta ad imperfezioni',
          pillClass: 'opt-pill--mista',
        },
        {
          value:     'stanca_segnata',
          primary:   '...rughe, perdita di tono, macchie e discromie. La mia pelle appare stanca e l\'incarnato è poco luminoso.',
          secondary: 'Pelle stanca/segnata/non uniforme',
          pillClass: 'opt-pill--stanca',
        },
      ],
    },

    /* Q3 — Desiderio
       Le label primarie sono brevi; le label estese sono il testo narrativo secondario.
       primary = etichetta breve | extended = descrizione narrativa
    */
    desire: {
      label:   '3 di 4 · Il tuo desiderio',
      title:   'Esprimi un desiderio: \u201cVorrei una pelle più\u2026\u201d',
      options: [
        {
          value:    'levigata_rimpolpata',
          emoji:    '✨',
          primary:  '\u2026levigata, rimpolpata e luminosa',
          extended: 'Mi piacerebbe ridurre la visibilità di rughe e linee sottili e prevenire la comparsa dei principali segni dell\'invecchiamento cutaneo.',
        },
        {
          value:    'forte_morbida',
          emoji:    '💧',
          primary:  '\u2026forte, morbida e idratata',
          extended: 'Mi piacerebbe ridurre le linee sottili che compaiono sul mio viso ed eliminare quella fastidiosa sensazione di \u201cpelle che tira\u201d che spesso avverto nel corso della giornata.',
        },
        {
          value:    'libera_imperfezioni',
          emoji:    '🌿',
          primary:  '\u2026sana e uniforme, libera dalle imperfezioni',
          extended: 'Mi piacerebbe ridurre brufoli e punti neri, levigare la grana e regolare la produzione di sebo per limitare l\'effetto \u201cpelle lucida\u201d.',
        },
        {
          value:    'tonica_elastica',
          emoji:    '🌸',
          primary:  '...tonica, elastica e compatta',
          extended: 'Mi piacerebbe migliorare l\'elasticità, ridurre il rilassamento cutaneo specialmente nei contorni del viso e agire in modo mirato su rughe e segni del tempo.',
        },
        {
          value:    'uniforme_luminosa',
          emoji:    '☀️',
          primary:  '...uniforme e luminosa',
          extended: 'Mi piacerebbe ridurre estensione ed intensità di macchie e discromie, migliorare il colorito e dare un po\' di energia alla mia pelle.',
        },
      ],
    },

    /* Q4 — SPF (non diagnostica — solo CRM)
       La risposta viene salvata come quiz_spf_habit ma non entra nella lookup.
    */
    spf: {
      label:   '4 di 4 · La tua protezione solare',
      title:   'Quando applichi la protezione solare?',
      options: [
        {
          value:    'sempre',
          emoji:    '☀️',
          primary:  'Sempre',
          extended: 'Tutti i giorni anche in inverno e anche in città, è parte della mia skincare routine quotidiana.',
        },
        {
          value:    'a_volte',
          emoji:    '🌤️',
          primary:  'A volte',
          extended: 'Durante le giornate di sole se devo uscire per una passeggiata o per fare sport all\'aperto.',
        },
        {
          value:    'solo_al_mare',
          emoji:    '🌊',
          primary:  'Solo al mare',
          extended: 'In estate e solo quando vado in spiaggia.',
        },
        {
          value:    'raramente',
          emoji:    '🌙',
          primary:  'Raramente',
          extended: 'Ogni tanto, quando mi ricordo.',
        },
        {
          value:    'mai',
          emoji:    '🌿',
          primary:  'Mai',
          extended: 'Non ne ho bisogno perché ho la carnagione scura.',
        },
      ],
    },

  },

  /* ----------------------------------------------------------------
     2. TESTI CTA SCONTO
     Testi del blocco codice sconto e della sticky bar sconto.
     {PCT}  = percentuale sconto automatica
     {CODE} = codice sconto attivo
  ---------------------------------------------------------------- */
  discount: {

    // Sticky bar — clienti nuovi
    stickyNCTitle:   'Hai sbloccato il tuo sconto: -{PCT}%',
    stickyNCBody:    'Il codice {CODE} è già applicato al tuo carrello',

    // Sticky bar — clienti di ritorno
    stickyRCTitle:   'Il tuo sconto fedeltà è attivo',
    stickyRCBody:    'Il {PCT}% sul secondo prodotto in carrello è già applicato con {CODE}',

    // Titolo box sconto — clienti nuovi
    newCtaTitle:     'Il tuo sconto di benvenuto',

    // Testo esplicativo — clienti nuovi
    newCtaSub:       'Controlla la tua email. Hai ricevuto il tuo protocollo e il codice sconto per iniziare.',

    // Titolo box sconto — clienti di ritorno
    returnCtaTitle:  'È BELLO RIVEDERTI',

    // Testo esplicativo — clienti di ritorno. Usa {CODE} e {PCT}
    returnCtaSub:    'Con il codice {CODE} al checkout pagherai il secondo prodotto in carrello al {PCT}%. Puoi usarlo una sola volta per il tuo acquisto. È già applicato al tuo carrello. Approfittane!',

    // Etichetta badge sconto cliente nuovo. Usa {PCT}
    newBadgeLabel:   '-{PCT}',

    // Nota sotto il badge cliente nuovo
    newBadgeNote:    'Sconto applicato automaticamente alla cassa.',

    // Nota sotto il badge cliente di ritorno
    returnBadgeNote: 'Lo sconto si applica automaticamente alla cassa.',

    // Prefisso seconda riga prezzo nel popup varianti (clienti di ritorno)
    varPriceSecondLine: 'Il secondo lo pagheresti',

  },

  /* ----------------------------------------------------------------
     3. TESTI PAGINA RISULTATO
  ---------------------------------------------------------------- */
  result: {

    /* ── Header sezioni ──────────────────────────────────────────── */
    coreSectionHeader:    'La tua routine personalizzata',
    tipsSectionHeader:    'I nostri Skön Tips per te',

    /* ── Step label nelle card prodotto ──────────────────────────── */
    // Renderizzati come 'FASE 1', 'FASE 2', ecc. (core)
    //                e 'TIP 1', 'TIP 2', ecc. (tips)
    stepLabelCore:        'FASE',
    stepLabelTip:         'TIP',

    /* ── Card prodotto ───────────────────────────────────────────── */
    // Label "Perché per te" — può ricevere apostrofo + nome utente in coda
    // tramite logica skon-quiz.js (S.userName), es: "Perché è l'ideale per te, Maria"
    whyForYouLabel:       'Perché è l’ideale per te',
    btnViewProduct:       'Vedi prodotto',
    btnInterested:        'Mi interessa',

    /* ── CTA "Aggiungi tutto" (uno per sezione) ──────────────────── */
    ctaAddRoutine:        'Aggiungi tutta la routine al carrello',
    ctaAddTips:           'Aggiungi anche i Tips',

    /* ── Stati post-click bottoni ────────────────────────────────── */
    // Add-all parziale: supporta interpolazione {{ok}}/{{total}}
    // (Il successo completo non passa più di qui in v2.4.0+: l'utente
    // viene reindirizzato al checkout dopo il toast — vedi toastRoutineAdded)
    cartAddedPartial:     'Aggiunto ({{ok}}/{{total}})',
    // Bottone "Mi interessa" e ATC variante singola dopo successo
    cartAdded:            '✔ Aggiunto!',
    // Stato breve per lightbox AK (variante singola)
    cartAddedShort:       'Aggiunto ✓',

    /* ── Detail sheet & variant sheet ────────────────────────────── */
    btnAddToCart:         'Aggiungi al carrello',
    btnViewFullPage:      'Vedi la pagina completa',

    /* ── Lightbox AK (varianti tonalità) ─────────────────────────── */
    // Supporta interpolazione {{code}} = nome della variante (es. 'Light 02')
    btnAddVariantToCart:  'Aggiungi {{code}} al carrello',

    /* ── Restart ─────────────────────────────────────────────────── */
    restartPrompt:        'Vuoi rifare il test?',
    restartBtn:           'Rifai il test',

    /* ── Variant sheet — etichette extra ─────────────────────────── */
    varSectionLabel:      'Seleziona la variante',
    btnViewProductSheet:  'Vedi prodotto',

    /* ── Bottone "Aggiungi tutta la routine" — sub-line RC ─────────
       Placeholder neutro: sarà sostituito da calcolo live in v2.6+ */
    ctaAddRoutineSubRC:   'Lo sconto si applica automaticamente al carrello',

    /* ── Stato "Aggiungo..." durante le fetch /cart/add.js ────────── */
    ctaAddingShort:       'Aggiungo\u2026',

    /* ── Toast pre-redirect al checkout (v2.4.0+) ───────────────────
       Mostrato per 2s dopo l'add-to-cart di tutti i 4 core,
       prima del window.location.href = /discount/CODE?redirect=/checkout */
    toastRoutineAdded:    'Routine aggiunta \u2014 vai al checkout',
    toastRoutineError:    'Aggiunti {{ok}} di {{total}} prodotti. Riprova per gli altri.',

  },

  /* ----------------------------------------------------------------
     4. DATABASE PRODOTTI
     slug    — descrizione breve del tipo prodotto (sotto il nome nella card)
     tagline — frase breve (nel detail sheet / interest sheet)
     why     — motivazione nella card risultato ("Perché è l'ideale per te")
               Fonte: foglio "Product Description" — Sko_n_Skin_Test_V3.xlsx
  ---------------------------------------------------------------- */
  products: {

    /* Abrakadabra Glow */
    ak_glow: {
      slug:    'Siero fondotinta illuminante SPF30',
      tagline: "Idrata, uniforma e illumina l'incarnato.",
      why:     "La formula magica per un make-up leggero e luminoso. Grazie ad una formula arricchita con Acido Ialuronico, Vitamina E ed Estratto di Fico d'India con il plus della protezione solare, il prodotto uniforma l'incarnato, idrata e rimpolpa la pelle proteggendola dai raggi UVA-UVB durante la giornata.",
    },

    /* Abrakadabra Soft Matt */
    ak_matt: {
      slug:    'Siero fondotinta opacizzante SPF30',
      tagline: "Idrata, uniforma e assorbe l'eccesso di sebo.",
      why:     "La formula magica per un make-up matt a lunga durata. Grazie ad una formula arricchita con Acido Ialuronico, Vitamina E ed Estratto di Fico d'India con il plus della protezione solare, il prodotto uniforma l'incarnato, regola la produzione di sebo e idrata la pelle proteggendola dai raggi UVA-UVB durante la giornata.",
    },

    /* Arctic Waterfalls */
    arctic_waterfalls: {
      slug:    "Siero idratante all'Acido Ialuronico",
      tagline: 'Idrata, lenisce e rimpolpa la pelle in profondità.',
      why:     "Siero ad azione dissetante e rimpolpante che agisce in profondità grazie all'elevata concentrazione di Acido Ialuronico presente in formula. Migliora elasticità e tono alla pelle contrastando e prevenendo la formazione di rughe e linee sottili.",
    },

    /* Bakuplex® Face Cream */
    bakuplex_crema_viso: {
      slug:    'Crema antietà globale Bakuplex®',
      tagline: 'Rimpolpa, nutre e riduce rughe e linee sottili per una pelle visibilmente più uniforme e levigata.',
      why:     "Crema ad azione antietà globale che completa il trattamento potenziando l'efficacia del siero per una pelle giorno dopo giorno più tonica, elastica e levigata. La texture a rapido assorbimento dal finish vellutato nutre intensamente la pelle regalando un'immediata sensazione di comfort.",
    },

    /* Bakuplex® Face Serum */
    bakuplex_serum: {
      slug:    'Siero antietà globale Bakuplex®',
      tagline: 'Stimola il rinnovamento cellulare, contrasta rughe e segni del tempo.',
      why:     "Trattamento intensivo ad azione antietà globale che agisce in profondità. Favorisce la rigenerazione cellulare, contrasta lo stress ossidativo e stimola la produzione di Collagene ed Elastina.",
    },

    /* Better Late Than Never */
    better_late: {
      slug:    'Siero antietà levigante al Bakuchiol',
      tagline: 'Stimola la produzione di Collagene ed Elastina per una pelle più tonica e levigata.',
      why:     "Siero arricchito con Bakuchiol che leviga la grana della pelle, regola la produzione di sebo e riduce rughe e linee sottili stimolando la naturale produzione di Collagene ed Elastina.",
    },

    /* Clean Me Up Cleansing Balm */
    cmu_balm: {
      slug:    'Burro detergente struccante',
      tagline: 'Elimina il make-up, nutre, rigenera.',
      why:     "Il segreto di una skincare completa ed efficace inizia dalla detersione. La sera, il burro detergente struccante dalla texture cremosa e avvolgente rimuove delicatamente il make-up anche waterproof, il sebo e l'inquinamento accumulati durante la giornata, nutrendo e rigenerando la pelle.",
    },

    /* Clean Me Up Cleansing Gel */
    cmu_gel: {
      slug:    'Gel detergente',
      tagline: 'Deterge, idrata, lenisce.',
      why:     "Gel detergente dalla texture soffice e cremosa a basso potere schiumogeno che elimina delicatamente impurità, sebo, inquinamento e residui di make-up. Indicato per la detersione quotidiana del viso mattina e/o sera.",
    },

    /* Clean Me Up Cleansing Mousse */
    cmu_mousse: {
      slug:    'Mousse detergente',
      tagline: 'Deterge, idrata, lenisce.',
      why:     "Mousse detergente dalla texture soffice e cremosa che elimina delicatamente impurità, sebo, inquinamento e residui di make-up rispettando il microbioma della pelle. Indicata per la detersione quotidiana del viso mattina e/o sera.",
    },

    /* Clean Me Up Cleansing Oil */
    cmu_oil: {
      slug:    'Olio detergente struccante',
      tagline: 'Elimina il make-up, nutre, rigenera.',
      why:     "Il segreto di una skincare completa ed efficace inizia dalla detersione. La sera, l'olio detergente struccante dalla texture cremosa e avvolgente rimuove delicatamente make-up anche waterproof, sebo e inquinamento accumulati durante la giornata, nutrendo e rigenerando la pelle.",
    },

    /* Clean Me Up Energy Essence */
    cmu_essence: {
      slug:    'Essenza idratante antiossidante',
      tagline: 'Idrata, rinforza e prepara la pelle alla skincare.',
      why:     "Un boost di energia per la tua pelle. Dopo la detersione e prima dei trattamenti, questa essenza dalla texture water-like prepara la pelle a ricevere i trattamenti skincare successivi migliorandone l'assorbimento e potenziandone l'efficacia.",
    },

    /* Collagen Elixir */
    booster_collagene: {
      slug:    'Integratore pro-collagene vegano',
      tagline: 'Stimola la naturale produzione di Collagene.',
      why:     "Potenzia la tua skincare routine agendo dall'interno. Grazie ad una miscela di ingredienti selezionati, stimola la naturale produzione di Collagene da parte dell'organismo, rinforza pelle, capelli, unghie e articolazioni e svolge un'efficace azione antiossidante.",
    },

    /* Forever Young Lifting Eye Cream */
    fy_eye_cream: {
      slug:    'Contorno occhi levigante rimpolpante',
      tagline: 'Riduce rughe, borse e occhiaie.',
      why:     "Crema contorno occhi dalla texture morbida e setosa che riduce rughe, borse ed occhiaie e rilassa la mimica della zona perioculare per uno sguardo più fresco e disteso.",
    },

    /* Forever Young Proaging Cream */
    forever_young_cream: {
      slug:    'Crema levigante rimpolpante',
      tagline: 'Riduce rughe e linee sottili.',
      why:     "Crema viso dalla texture morbida ed avvolgente che previene e corregge i principali segni dell'invecchiamento cutaneo come secchezza, rughe, perdita di tono e luminosità.",
    },

    /* ImPerfect Blemish Control Cream */
    imperfect_cream: {
      slug:    'Crema anti-imperfezioni',
      tagline: 'Purifica, idrata, lenisce.',
      why:     "Crema viso che riduce le imperfezioni prevenendone la ricomparsa, regola la produzione di sebo, idrata la pelle e lenisce rossori e infiammazioni. Texture gel-crema a rapido assorbimento, ideale come base make-up quotidiana.",
    },

    /* ImPerfect Cleansing Gel */
    imperfect_gel_cleanser: {
      slug:    'Gel detergente anti-imperfezioni',
      tagline: 'Purifica, idrata, lenisce.',
      why:     "Gel detergente dalla texture fresca e leggera a basso potere schiumogeno che elimina delicatamente impurità e residui di make-up, regola la produzione di sebo e aiuta a ridurre le imperfezioni prevenendone la ricomparsa.",
    },

    /* ImPerfect Exfoliating Lotion */
    imperfect_exfol: {
      slug:    'Lozione esfoliante',
      tagline: 'Purifica, leviga la grana della pelle, illumina.',
      why:     "Il gesto che leviga la grana della pelle e migliora la luminosità. La lozione esfoliante dalla texture water-like leviga la grana della pelle, regola la produzione di sebo, riduce imperfezioni come brufoli e punti neri prevenendone la ricomparsa e stimola il rinnovamento cellulare garantendo un incarnato più uniforme e luminoso.",
    },

    /* Over The Moon */
    over_the_moon: {
      slug:    'Crema anti-macchia uniformante',
      tagline: 'Riduce macchie e discromie.',
      why:     "Crema viso ad azione anti-macchia che aiuta a ridurre l'estensione ed intensità di macchie, discromie e iperpigmentazioni prevenendone la ricomparsa.",
    },

    /* Pimple Potion */
    siero_imperfezioni: {
      slug:    'Siero anti-imperfezioni purificante',
      tagline: 'Riduce brufoli, punti neri e pori dilatati.',
      why:     "Siero ad azione anti-imperfezioni che aiuta a ridurre brufoli, punti neri e pori dilatati, migliora la grana della pelle e regola la produzione di sebo.",
    },

    /* Stay Soft Comfort Cream */
    staysoft_cream: {
      slug:    'Crema nutriente lenitiva',
      tagline: 'Nutre, lenisce e ristora la pelle secca e sensibile.',
      why:     "Crema nutriente dalla texture morbida e avvolgente a rapido assorbimento dedicata alle esigenze della pelle soggetta a disidratazione, secchezza, rossori e screpolature.",
    },

    /* Stay Soft Hydrating Eye Gel */
    staysoft_eye: {
      slug:    'Gel contorno occhi idratante lenitivo',
      tagline: 'Idrata e rimpolpa il contorno occhi in profondità.',
      why:     "Gel contorno occhi che idrata e rimpolpa in profondità riducendo secchezza e disidratazione della zona perioculare. Garantisce un'immediata sensazione di comfort e illumina il contorno occhi per uno sguardo più fresco e disteso già dalle prime applicazioni.",
    },

    /* Vitamin Blast */
    vitamin_blast: {
      slug:    'Crema illuminante alla Vitamina C',
      tagline: 'Uniforma il colorito e protegge dai radicali liberi.',
      why:     "Crema viso dalla texture leggera e avvolgente che, grazie alla presenza in formula della Vitamina C, svolge un'efficace azione antiossidante e illuminante.",
    },

  },

};